import { IConsumptionGlobalSummaryDTO, IConsumedType } from "@/interface"
import { UnitValueBalance } from "@/models/consumption/unit-value-balance"
import { ConsumptionSummaryTypeEnum } from "@/enums"
import { consumptionDataConstruction } from "@/helpers/function/consumptionDataConstructHelpers"

export interface consumptionDataChartInterface {
    [ConsumptionSummaryTypeEnum.CALL]: IConsumedType | null;
    [ConsumptionSummaryTypeEnum.DATA]: IConsumedType | null;
    [ConsumptionSummaryTypeEnum.SMS]: IConsumedType | null;
}

export class ConsumptionSummary {
    [ConsumptionSummaryTypeEnum.CALL]: UnitValueBalance | null;
    [ConsumptionSummaryTypeEnum.DATA]: UnitValueBalance | null;
    [ConsumptionSummaryTypeEnum.SMS]: UnitValueBalance | null;

    constructor(base?: Partial<ConsumptionSummary>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: IConsumptionGlobalSummaryDTO) {
        if (!dto) {
            return null;
        }
        return new ConsumptionSummary({
            [ConsumptionSummaryTypeEnum.CALL as ConsumptionSummaryTypeEnum]: UnitValueBalance.fromDto(dto, ConsumptionSummaryTypeEnum.CALL),
            [ConsumptionSummaryTypeEnum.DATA as ConsumptionSummaryTypeEnum]: UnitValueBalance.fromDto(dto, ConsumptionSummaryTypeEnum.DATA),
            [ConsumptionSummaryTypeEnum.SMS as ConsumptionSummaryTypeEnum]: UnitValueBalance.fromDto(dto, ConsumptionSummaryTypeEnum.SMS),
        });
    }

    public consumptionDataChart() {
        return {
            [ConsumptionSummaryTypeEnum.CALL]: consumptionDataConstruction(
                this[ConsumptionSummaryTypeEnum.CALL],
                ConsumptionSummaryTypeEnum.CALL
            ),
            [ConsumptionSummaryTypeEnum.DATA]: consumptionDataConstruction(
                this[ConsumptionSummaryTypeEnum.DATA],
                ConsumptionSummaryTypeEnum.DATA
            ),
            [ConsumptionSummaryTypeEnum.SMS]: consumptionDataConstruction(
                this[ConsumptionSummaryTypeEnum.SMS],
                ConsumptionSummaryTypeEnum.SMS
            )
        }
    }
}
